import React from "react";
import Skeleton from "react-loading-skeleton";

const ContentSkeleton = () => {
  return (
    <div>
      <Skeleton className="form-control" height="60vh" width={"100%"} />
    </div>
  );
};

export default ContentSkeleton;
